import { Link } from 'react-router-dom';
import { CustomMenu } from '@common/menus/custom-menu';
import { useSettings } from '@ui/settings/use-settings';

export function AuthLayoutFooter() {
  const { branding } = useSettings();
  return (
    <div className="mt-auto text-center gap-30 pb-5 pt-20 text-sm text-muted font-bold z-10">
      <Link className="transition-colors hover:text-fg-base" to="/">
        © {branding.site_name}
      </Link>
      <CustomMenu
        menu="auth-page-footer"
        orientation="horizontal"
        itemClassName="hover:text-fg-base transition-colors"
      />
    </div>
  );
}
